import { ServiceIdentifier } from '../service-locator';
import { YieldSpaceService } from './interfaces';

export * from './interfaces';

export const YIELDSPACE_SERVICE = ServiceIdentifier.get<YieldSpaceService>('YieldSpaceService');
